import { render, staticRenderFns } from "./advance.vue?vue&type=template&id=0be0a622&scoped=true"
import script from "./advance.vue?vue&type=script&lang=js"
export * from "./advance.vue?vue&type=script&lang=js"
import style0 from "./advance.vue?vue&type=style&index=0&id=0be0a622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be0a622",
  null
  
)

export default component.exports